// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__PyXWp","secondary":"Button_secondary__94ixV","disabled":"Button_disabled__BuCPc","base":"Button_base__SCUxE"};